export default __webpack_public_path__ + "images/f8f39649c823364a93c91392793fb0dd.svg";